




























import VueOptions from '@utils/VueOptions'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'RecapsPostsSummaryChart'

  vue:
    props: ['title', 'data', 'postsOnly']

    components: {
      BoxChart,
    }

    computed:
      total: ->
        @data?.total || 0

      reach: ->
        @data?.reach || 0

export default VueOptions.vue settings
